<div class="{{styles.textWrapper}}" style="width: {{typeof props.width === 'number' ? props.width + 'px' : props.width}}"><span class="{{styles.textWrapper_content}}">{{props.text || '没有数据...'}}</span></div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilter/text.art